import axios from 'axios';
import { getToday, dateToYmd } from '../helpers/DateHelper';

export default {
    fetchProgressForWorkstationTypes(date, workstationTypeIds) {
        let queryParameters = `date=${dateToYmd(date.toDate())}`;

        const uniqueWorkstationTypeIds = [...new Set(workstationTypeIds)];
        if (Array.isArray(uniqueWorkstationTypeIds)) {
            uniqueWorkstationTypeIds.forEach((id) => {
                queryParameters += `&workstationTypeIds[]=${id}`;
            });
        }

        return axios.get(`[API]/production-progress?${queryParameters}`);
    },
    // OLD
    fetchAllWorkstationTypes() {
        return axios.post('/workstation/fetchAllTypes/');
    },
    fetchProgress(day = null) {
        return axios.post('/productioninfo/fetchProgress/', {
            day: day ? dateToYmd(new Date(day)) : getToday(),
        });
    },
    fetchProductsPerWorkstation(day = null) {
        return axios.post('/product/fetchProductsPerWorkstationtypeForDay/', {
            day: day ? dateToYmd(new Date(day)) : getToday(),
        });
    },
    fetchNotFinishedProductsByDate(date) {
        return axios.get(`[API]/production-progress/not-finished-products`, {
            params: {
                date: dateToYmd(date.toDate()),
            },
        });
    },
    incrementProductionDatesByOne(date) {
        return axios.post(`[API]/production-progress/increment-production-dates`, {
            date: dateToYmd(date.toDate()),
        });
    },
};
